import React from 'react'
import { Disclosure } from '@headlessui/react'
import { HiMinus, HiPlus } from "react-icons/hi";
export default function Accordion({title,description}) {
  return (
    <>
     <Disclosure>
          {({ open }) => (
            <div className='bg-[#E4E6E3]   px-3 text-black text-title-xs'>
            
              <Disclosure.Button className="flex items-center font-bold w-full gap-x-2 rounded-lg  py-8 p text-black">
                {open ?
              <HiMinus 
                  className={` h-6 w-6 text-orange-500`}
                />
                :
                <HiPlus
                className={` h-6 w-6 `} /> }
                <span className='font-bold '>{title}</span>
              
              </Disclosure.Button>
              <Disclosure.Panel className=" px-2 md:px-8 pb-5 p">
              {description}
              </Disclosure.Panel>
            </div>
          )}
        </Disclosure>
    </>
  )
}
